'use client';
import { DangerousHtml } from '~components/DangerousHtml';
import { SubHeadline } from '~components/Typography';
import { useTranslations } from '~i18n/hooks';
import PlaceholderIcon from '~public/assets/icons/grid-filters-placeholder.svg';

import { ClearFiltersPlaceholderButton } from '../ClearFiltersPlaceholderButton';
import { PlaceholderContainer, TextContainer } from './styles';

export const GridPlaceholder = () => {
	const t = useTranslations('Grid');

	return (
		<PlaceholderContainer>
			<PlaceholderIcon />
			<TextContainer>
				<SubHeadline size="M">
					<DangerousHtml>{t('gridPlaceholderText')}</DangerousHtml>
				</SubHeadline>
				<ClearFiltersPlaceholderButton />
			</TextContainer>
		</PlaceholderContainer>
	);
};
